import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Paper } from '@material-ui/core';
import Routes from '../../router/routes';

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: '#fafafa',
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    padding: theme.spacing(0, 0, 0, 0),
    paddingLeft: 1,
  },
  paper: {
    backgroundColor: '#fafafa',
    padding: theme.spacing(1),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    borderRadius: 0,
    height: `calc(100vh - ${theme.mixins.toolbar.minHeight + theme.spacing(2)}px)`,

    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(5),
      height: 'calc(100vh - 144px)',
    },
  },
}));

export default function AppBody({ children }) {
  const classes = useStyles();

  return (
    <main className={classes.content}>
      <div className={classes.appBarSpacer} />

      <Container maxWidth={false} className={classes.container}>
        <Paper className={classes.paper}>
          <Routes />
        </Paper>
        { children }
      </Container>
    </main>
  );
}
